import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import WebMailBottom from '@/components/common/WebMailBottom.vue'
import MailList from '@mail/components/MailList.vue'
import ScheduleList from '@home/components/Search/ScheduleList.vue'
import ContactList from '@contact/components/List/ContactList.vue'
import { createEventBus, removeEventBus } from '@/util'
import { FilterComparisonModes, FilterConditions, WellKnownFolderName } from '@/modules/mail/types/enums'
import { FilterContainmentModes } from '@/modules/@orgmap/types/enums'
import mailApi from '@mail/api'
import contactApi from '@contact/api'
import calendarApi from '@calendar/api'
import { ContactsStoredType } from '@/modules/contact/types/enums'
import * as accountTypes from '@account/store/types'
import { mapGetters } from 'vuex'
@Component({
    components: { WebMailBottom, MailList, ScheduleList, ContactList },
    computed: {
        ...mapGetters({
            User: accountTypes.USER
        })
    }
})
export default class SearchContainer extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    mailList: mail.EmailMessage[] = []
    mailMoreAvailable: boolean | undefined = false

    scheduleList: ItemList<calendar.CalendarItem> = []
    scheduleMoreAvailable: boolean = false

    contactList: contacts.ContactItem[] = []

    searchKeyword: string = ''

    isLoading = {
        mail: false,
        calendar: false,
        contact: false
    }
    /*메일 폴더 2023-06-19 추가*/
    hasMailFolder: any[] = []

    /*더보기 2023-05-23*/
    offset: number = 0
    pageNumber: number = 1
    pageSize: number = 20
    loadMorePossible: boolean = true
    mailCount: number = 0
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    //페이지 정보 초기화
    clearPageInfo() {
        this.offset = 0
        this.pageNumber = 1
        this.mailList = []
    }

    // 헤더 검색 아이콘 클릭시 이벤트
    handleSearchRequest(keyword: string) {
        if (keyword) {
            this.clearPageInfo()
            this.searchKeyword = keyword
            this.isLoading.mail = true
            //this.isLoading.calendar = true
            //this.isLoading.contact = true
            this.getMailList(this.searchKeyword)
            //this.getScheduleList(this.searchKeyword)
            //this.getContactList(this.searchKeyword)
        } else {
            this.isloading(false)
            this.clearPageInfo()
            this.searchKeyword = ''
            this.scheduleList = []
            this.contactList = []
        }
    }

    // 메일 검색
    getMailList(keyword: string) {
        this.isloading(true)

        var promiseArr: Promise<any>[] = [
            mailApi.folder.getFolderTree('')
        ]


        Promise.all(promiseArr).then(res => {
            const filters: mail.api.FilterOption[] = [];

            this.hasMailFolder = res[0]['items']
            var folderId = ''
            for (var i = 0; i < this.hasMailFolder.length; i++) {
                var isDelete = false

                if(this.hasMailFolder[i]['name'] === '보낸 편지함' || this.hasMailFolder[i]['name'] === '보낼 편지함' || this.hasMailFolder[i]['name'] === '임시 보관함' || this.hasMailFolder[i]['name'] === '정크 메일' ||this.hasMailFolder[i]['name'] === '지운 편지함')
                {
                    isDelete = true
                } 

                if(isDelete === true){
                    this.hasMailFolder.splice(i,1) 
                    i--

                }  else {
                    folderId += ',' + this.hasMailFolder[i]['id'] 
                }
            }

            if (keyword) {
                filters.push({
                    operator: 'or',
                    filters: [
                        {
                            key: 'Subject',
                            value: keyword,
                            condition: FilterConditions.ContainsSubstring,
                            containmentMode: FilterContainmentModes.Substring,
                            comparisonMode: FilterComparisonModes.IgnoreCase,
                        },
                        {
                            key: 'From',
                            value: keyword,
                            condition: FilterConditions.ContainsSubstring,
                            containmentMode: FilterContainmentModes.Substring,
                            comparisonMode: FilterComparisonModes.IgnoreCase,
                        },
                        {
                            key: 'PR_DISPLAY_TO_W',
                            value: keyword,
                            condition: FilterConditions.ContainsSubstring,
                            containmentMode: FilterContainmentModes.Substring,
                            comparisonMode: FilterComparisonModes.IgnoreCase,
                        }
                        ,{
                            key: 'PR_DISPLAY_CC_W',
                            value: keyword,
                            condition: FilterConditions.ContainsSubstring,
                            containmentMode: FilterContainmentModes.Substring,
                            comparisonMode: FilterComparisonModes.IgnoreCase,
                        }
                        ,{
                            key: 'PR_SENDER_NAME',
                            value: keyword,
                            condition: FilterConditions.ContainsSubstring,
                            containmentMode: FilterContainmentModes.Substring,
                            comparisonMode: FilterComparisonModes.IgnoreCase,
                        }
                        ,{
                            key: 'Body',
                            value: keyword,
                            condition: FilterConditions.ContainsSubstring,
                            containmentMode: FilterContainmentModes.Substring,
                            comparisonMode: FilterComparisonModes.IgnoreCase,
                        }
                       
                    ],
                } as mail.api.FilterOption);
            }

            /*offset 추가 2023.06.22*/
            this.offset = (this.pageNumber -1) * this.pageSize

            var data: mail.api.DynamicApiOptions = {
                fields: [
                    { key: 'From', format: 'obj:[name,address]', as: 'fromS' },
                ],
                filters: filters,
                parentId: folderId, //폴더 아이디 추가 2023-06-19
                pageSize: this.pageSize,
                offset: this.offset,
                type: 'EmailMessage'
                ,isIncludeChildSearch: true //포함 여부 추가 2023-05-26
            };

            if(this.hasMailFolder.length){
            
                /* 검색 전용 Method 추가 2023-06-19 */
                mailApi.mail.getSearchPagedList(data).then((emails) => {
                    if (emails.items.length) {
  
                        this.mailCount = Number(emails.totalCount || 0) //총 개수
                        console.log('mailCount' + this.mailCount)
                        if(this.pageNumber > 1) {
                            this.mailList = [...(this.mailList || []), ...emails.items]
                        } else {
                            this.mailList = emails.items
                            this.isLoading.mail = false
                        }

                        this.isloading(false)

                    } else {
                        //this.mailList = []
                        this.isLoading.mail = false
                        this.isloading(false)
                        //this.loadMorePossible = false
                    }
                })
            }
        })
    }

    // 연락처 검색
    getContactList(keyword: string) {
        const filters: mail.api.FilterOption[] = [
            {
                operator: 'or',
                filters: [
                    {
                        key: 'ItemClass',
                        value: 'IPM.Contact',
                        condition: FilterConditions.IsEqualTo,
                    },
                    {
                        key: 'ItemClass',
                        value: 'IPM.DistList',
                        condition: FilterConditions.IsEqualTo,
                    },
                ],
            },
        ];

        //#region [검색어 설정]
        if (keyword) {
            filters.push({
            operator: 'or',
            filters: [
                    {
                        key: 'DisplayName',
                        value: keyword,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.Substring,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    },
                    {
                        key: 'DisplayName',
                        value: keyword,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.Prefixed,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    },
                    {
                        key: 'DisplayName',
                        value: keyword,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.FullString,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    },
                    {
                        key: 'DisplayName',
                        value: keyword,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.ExactPhrase,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    },
                    {
                        key: 'DisplayName',
                        value: keyword,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.PrefixOnWords,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    },
                    {
                        key: 'CompanyName',
                        value: keyword,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.Substring,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    },
                    {
                        key: 'EmailAddress1',
                        value: keyword,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.Substring,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    },
                    {
                        key: 'PidLidEmail1OriginalDisplayName',
                        value: keyword,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.Substring,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    },
                    {
                        key: 'MobilePhone',
                        value: keyword,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.Substring,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    },
                    {
                        key: 'JobTitle',
                        value: keyword,
                        condition: FilterConditions.ContainsSubstring,
                        containmentMode: FilterContainmentModes.Substring,
                        comparisonMode: FilterComparisonModes.IgnoreCase,
                    },
                ],
            });
        }

        const data: mail.api.DynamicApiOptions = {
            fields: [],
            filters: filters,
            parentId: null,
            sorts: [],
            pageSize: 50,
            offset: 0,
            wellKnownParentName: WellKnownFolderName.Contacts,
            type: 'Contact'
        };
        contactApi.contact.getContactsList(data, ContactsStoredType.EWS).then((res) => {
            this.isLoading.contact = false
            this.contactList = res.items
        })
    }

    // 일정 검색
    getScheduleList(keyword: string) {
        var searchOptions: calendar.SearchOptions = {
            EwsFolderIDArray: null,
            FolderIDArray: null,
            ParentFolderID: null,
            Keyword: keyword,
            Status: null,
            Subject: null,
            Location: null,
            OrganizerName: null,
            OrganizerAddress: null,
            RequiredAttendees: null,
            OptionalAttendees: null,
            StartDate: null,
            EndDate: null,
            PersonCode: this.User.personCode,
            EumPageNumber: 1,
            EumRowsPerPage: 10,
            EXTFIELD_1: null,
            EXTFIELD_2: null,
        }
        calendarApi.ews_calendar.searchCalendarEventList(searchOptions).then(res => {
            this.isLoading.calendar = false
            if (res.length > 5) {
                this.scheduleList = res.splice(0, 5)
                this.scheduleMoreAvailable = true
            } else {
                this.scheduleList = res
            }
        })
    }

    // 메일 검색결과 더보기
    mailMore() {
        this.$router.push({
            name: 'mail-list',
            query: { query: this.searchKeyword }
        })
    }

    @Watch('isLoading', {deep: true})
    onChangedIsLoading(loading: any) {
        var mail = loading.mail 
        var calendar = loading.calendar 
        var contact = loading.contact
        if (mail && calendar && contact) {
            this.isloading(true)
        } else if (!mail && !calendar && !contact) {
            this.isloading(false)
        }
    }

     //더보기 2023-05-23 추가
     loadMore() {
            if (this.loadMorePossible && this.mailCount > 20) {
                this.pageNumber ++
                
                this.getMailList(this.searchKeyword)
            }
        }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        createEventBus(window, 'header-search', this.handleSearchRequest)
    }

    beforeDestroy() {
        removeEventBus(window, 'header-search', this.handleSearchRequest)
    }
}
